<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Check out — booking #{{ data.requisitionId }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>
  <span class="dialog-sub">{{ data.name }} · Family {{ data.familyCode }}</span>

  <form [formGroup]="form" class="dialog-form">
    <label class="checkbox-row">
      <input type="checkbox" formControlName="outRegisterSigned" />
      <span>Out-register signed</span>
    </label>

    <div class="field">
      <span class="field-label">Key received by</span>
      <input type="text" class="text-box-active" formControlName="keyRecieptUser" />
    </div>

    <div class="field">
      <span class="field-label">Out-register signed by</span>
      <input type="text" class="text-box-active" formControlName="outRegSignedUser" />
    </div>

    <div class="field">
      <span class="field-label">Comments category</span>
      <select class="text-box-active" formControlName="commentsCategory">
        <option value="">Not set</option>
        @for(c of commentCategories; track c){ <option [value]="c">{{ c }}</option> }
      </select>
    </div>

    <div class="field">
      <span class="field-label">Devotee rating</span>
      <select class="text-box-active" formControlName="devoteeRating">
        <option [ngValue]="null">Not rated</option>
        @for(r of ratings; track r){ <option [ngValue]="r">{{ r }} / 5</option> }
      </select>
    </div>

    <div class="field">
      <span class="field-label">Additional comments</span>
      <textarea class="text-box-active" rows="2" formControlName="additionalComments"></textarea>
    </div>

    <div class="field">
      <span class="field-label">Devotee feedback</span>
      <textarea class="text-box-active" rows="2" formControlName="devoteeFeedback"></textarea>
    </div>
    <label class="checkbox-row acceptance">
      <input type="checkbox" formControlName="checkerFinalAcceptance" />
      <span>
        I have received the keys from the primary requestor and they have signed the
        checkout register. I have checked the room/hall and found no belongings left behind.
      </span>
    </label>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-danger-btn" [disabled]="!form.value.checkerFinalAcceptance" (click)="submit()">Check out</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
